import styled from "styled-components";

export const AccessibleMarketsSections = styled.section`
  .cards__container {
    margin-top: 3.75rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 1.625rem;
  }
`;
